import React, { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Home, HelpCircle, LogOut, Settings, Building2, UserCog } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import AppSidebar, { FirmSidebarLogoHeader, SidebarItem } from '../shell/AppSidebar';
import { AppShell, AppShellBody, AppShellTopRow } from '../shell/AppShell';
import { FirmMainHeaderSetterContext } from './FirmMainHeaderContext';
import { getInitialSidebarCollapsed } from '../../utils/initialSidebarCollapsed';
import { openAppHelp } from '../../utils/appHelp';

export default function FirmLayout() {
  const { logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const isDashboard = location.pathname === '/firm' || location.pathname === '/firm/';
  const isCompanies = location.pathname.startsWith('/firm/companies');
  const isUsers = location.pathname.startsWith('/firm/users');
  const isSettings = location.pathname === '/firm/settings';
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => getInitialSidebarCollapsed());
  const [mainHeader, setMainHeader] = useState(null as JSX.Element | null);

  return (
    <FirmMainHeaderSetterContext.Provider value={setMainHeader}>
      <AppShell>
        <AppShellTopRow
          logo={
            <FirmSidebarLogoHeader
              collapsed={sidebarCollapsed}
              onToggleCollapsed={() => setSidebarCollapsed((v) => !v)}
            />
          }
          header={mainHeader}
        />
        <AppShellBody
          sidebar={
            <AppSidebar
              collapsed={sidebarCollapsed}
              onToggleCollapsed={() => setSidebarCollapsed((v) => !v)}
              omitLogoHeader
              footer={
                <>
                  <SidebarItem icon={HelpCircle} label="Help" onClick={openAppHelp} collapsed={sidebarCollapsed} />
                  <SidebarItem
                    icon={Settings}
                    label="Settings"
                    active={isSettings}
                    onClick={() => navigate('/firm/settings')}
                    collapsed={sidebarCollapsed}
                  />
                  <SidebarItem
                    icon={LogOut}
                    label="Sign out"
                    variant="danger"
                    onClick={logout}
                    collapsed={sidebarCollapsed}
                  />
                </>
              }
            >
              <SidebarItem
                icon={Home}
                label="Dashboard"
                active={isDashboard}
                onClick={() => navigate('/firm')}
                collapsed={sidebarCollapsed}
              />
              <SidebarItem
                icon={Building2}
                label="Companies"
                active={isCompanies}
                onClick={() => navigate('/firm/companies')}
                collapsed={sidebarCollapsed}
              />
              <SidebarItem
                icon={UserCog}
                label="Law Firm Users"
                active={isUsers}
                onClick={() => navigate('/firm/users')}
                collapsed={sidebarCollapsed}
              />
            </AppSidebar>
          }
        >
          <Outlet />
        </AppShellBody>
      </AppShell>
    </FirmMainHeaderSetterContext.Provider>
  );
}
